import { jsx as o } from "react/jsx-runtime";
import { Loader as c } from "./contact-channels76.js";
import { useTranslations as l } from "./contact-channels38.js";
import { useWhatsApp as h } from "./contact-channels7.js";
import { FlexBox as f, Typography as g } from "@vp/swan";
const b = (t) => {
  const { variation: e = "standard", showLoading: r = !0 } = t, { t: i } = l(), { data: n, isLoading: s, isPending: a } = h(), p = !(n != null && n.isAvailable) || s, d = e === "minimal", m = i(p ? "whatsApp.offline.description" : "whatsApp.online.description");
  return /* @__PURE__ */ o(c, { skeletonLines: d ? 2 : 1, isLoading: s || a, showLoading: r, children: /* @__PURE__ */ o(f, { children: /* @__PURE__ */ o(g, { component: "span", fontSize: "standard", children: m }) }) });
};
export {
  b as WhatsAppContent
};
//# sourceMappingURL=contact-channels34.js.map
